/**
 * The Torvanis monogram: three ascending bars forming a `T`, painted with the
 * brand gradient. Colours come from the token custom properties, never from a
 * hex literal in a component (quality/coding-conventions).
 *
 * Extracted from the app shell so screens rendered outside the chrome — the
 * sign-in page, error pages — can carry the same mark.
 */

export function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" className={className}>
      <defs>
        <linearGradient
          id="tvm-brand-gradient"
          x1="0"
          y1="64"
          x2="64"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="var(--brand-red)" />
          <stop offset="1" stopColor="var(--brand-orange)" />
        </linearGradient>
      </defs>
      <g fill="url(#tvm-brand-gradient)">
        <rect x="5" y="17" width="14" height="9" rx="2" />
        <rect x="45" y="4" width="14" height="22" rx="2" />
        <rect x="25" y="10" width="14" height="49" rx="2" />
      </g>
    </svg>
  );
}
